import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
    Skeleton,
} from '@longy/web-components'
import { ImageOff } from 'lucide-react'

import { useFileImage } from '../../hooks/useFileImage'

interface FileImage {
    file: {
        id: string
    }
}

interface ImageCarouselProps {
    alt: string
    images: FileImage[]
}

const CarouselSlide = ({ alt, fileId }: { alt: string; fileId: string }) => {
    const { imageUrl, isLoading } = useFileImage(fileId)

    if (isLoading) {
        return <Skeleton className="aspect-[2/1] w-full rounded-2xl" />
    }

    if (!imageUrl) {
        return (
            <div className="flex aspect-[2/1] w-full items-center justify-center rounded-2xl bg-slate-100">
                <ImageOff aria-hidden className="size-10 text-slate-300" />
            </div>
        )
    }

    return (
        <img
            alt={alt}
            className="h-auto max-h-[70vh] w-full rounded-2xl object-contain"
            src={imageUrl}
        />
    )
}

export const ImageCarousel = ({ alt, images }: ImageCarouselProps) => {
    if (images.length === 0) {
        return (
            <div className="flex aspect-[2/1] w-full items-center justify-center rounded-2xl bg-slate-100">
                <span className="text-brand-gray">Nincs kép</span>
            </div>
        )
    }

    if (images.length === 1) {
        return <CarouselSlide alt={alt} fileId={images[0].file.id} />
    }

    return (
        <Carousel className="w-full">
            <CarouselContent className="items-center">
                {images.map((image) => (
                    <CarouselItem key={image.file.id}>
                        <CarouselSlide alt={alt} fileId={image.file.id} />
                    </CarouselItem>
                ))}
            </CarouselContent>
            <CarouselPrevious className="left-4" />
            <CarouselNext className="right-4" />
        </Carousel>
    )
}
